const VariableTimeSpecificRevenueTypes = {
    DAILY_ECPM: "VariableTimeSpecificRevenueTypes.ECPM",
    DAILY_REVENUE: "VariableTimeSpecificRevenueTypes.DailyRevenue",
    REVENUE_STATS: "VariableTimeSpecificRevenueTypes.RevenueStats"
}
export default VariableTimeSpecificRevenueTypes;